export default __webpack_public_path__ + "static/media/splitjump_thumb.67a0bac5.png";